// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { UserOut } from './userOut.zod.ts';

export const UserListOut = zod.object({
  "users": zod.array(UserOut)
});

export type UserListOut = zod.input<typeof UserListOut>;
export type UserListOutOutput = zod.output<typeof UserListOut>;
